/* S. Studio — gender-split.js
   "For Him / For Her" chooser: real-time CSS dial hands, letter-split titles, cursor glow,
   remembered last pick, and a full-screen expand from the clicked panel before navigating. */
(function () {
  'use strict';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const KEY = 'ss-gender';

  function init(root) {
    if (!root || root.__gsplit) return;
    root.__gsplit = true;
    const panels = Array.from(root.querySelectorAll('[data-gpanel]'));

    // Dial hands: CSS spins them (60s / 1h / 12h); negative delays start them at the current time.
    const d = new Date();
    const s = d.getSeconds() + d.getMilliseconds() / 1000, m = d.getMinutes() * 60 + s, h = (d.getHours() % 12) * 3600 + m;
    root.querySelectorAll('[data-hand="s"]').forEach((el) => { el.style.animationDelay = -s + 's'; });
    root.querySelectorAll('[data-hand="m"]').forEach((el) => { el.style.animationDelay = -m + 's'; });
    root.querySelectorAll('[data-hand="h"]').forEach((el) => { el.style.animationDelay = -h + 's'; });

    // Split the big title into letters for the staggered lift on hover.
    root.querySelectorAll('.gpanel__big').forEach((el) => {
      const text = el.textContent.trim();
      el.setAttribute('aria-label', text);
      el.innerHTML = Array.from(text).map((ch, i) => `<span aria-hidden="true" style="--i:${i}">${ch === ' ' ? '&nbsp;' : ch}</span>`).join('');
    });

    // Remember the shopper's last pick.
    let last = null;
    try { last = localStorage.getItem(KEY); } catch (e) {}
    panels.forEach((p) => p.classList.toggle('is-last', p.dataset.gpanel === last));

    // Cursor-follow glow + hover state on the wrapper (lets the other panel dim).
    const wrap = root.querySelector('.gsplit__wrap');
    panels.forEach((p) => {
      p.addEventListener('pointermove', (e) => {
        const r = p.getBoundingClientRect();
        p.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        p.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
      p.addEventListener('pointerenter', () => { wrap.dataset.active = p.dataset.gpanel; p.classList.add('is-hover'); });
      p.addEventListener('pointerleave', () => { delete wrap.dataset.active; p.classList.remove('is-hover'); });
      p.addEventListener('focus', () => { wrap.dataset.active = p.dataset.gpanel; });
      p.addEventListener('blur', () => { delete wrap.dataset.active; });

      p.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        try { localStorage.setItem(KEY, p.dataset.gpanel); } catch (err) {}
        if (reduceMotion) return;
        e.preventDefault();
        expand(p);
      });
    });
  }

  function expand(panel) {
    const r = panel.getBoundingClientRect();
    const zoom = document.createElement('div');
    zoom.className = 'gzoom gzoom--' + panel.dataset.gpanel;
    zoom.style.setProperty('--tint', panel.style.getPropertyValue('--tint'));
    Object.assign(zoom.style, { top: r.top + 'px', left: r.left + 'px', width: r.width + 'px', height: r.height + 'px' });
    const small = panel.querySelector('.gpanel__small'), big = panel.querySelector('.gpanel__big');
    zoom.innerHTML = `<div class="gzoom__inner"><span class="gzoom__small">${small ? small.textContent : ''}</span>` +
      `<span class="gzoom__big">${big ? (big.getAttribute('aria-label') || big.textContent) : ''}</span>` +
      `<span class="gzoom__bar"><i></i></span><span class="gzoom__note">Opening the collection</span></div>`;
    document.body.appendChild(zoom);
    panel.classList.add('is-chosen');
    void zoom.offsetWidth; // commit the start rect so the expand transition runs
    zoom.classList.add('is-open');
    setTimeout(() => {
      const url = new URL(panel.href, location.href);
      window.location.href = url.href;
      // Same-page links (e.g. #anchor) don't reload, so clear the overlay ourselves.
      if (url.pathname === location.pathname && url.search === location.search) {
        setTimeout(() => { zoom.classList.add('is-leaving'); setTimeout(() => { zoom.remove(); panel.classList.remove('is-chosen'); }, 500); }, 300);
      }
    }, 900);
  }

  // Back button (bfcache): remove a leftover overlay.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.gzoom').forEach((z) => z.remove());
    document.querySelectorAll('.gpanel.is-chosen').forEach((p) => p.classList.remove('is-chosen'));
  });

  const boot = () => document.querySelectorAll('[data-gsplit]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-gsplit]')));
})();
